import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import OrderLoanTable from "../KYC/OrderLoanTable";
import { IoMdClose } from "react-icons/io";
import SecurityDetails from "../../components/SecurityDetails";

// import Lottie from "react-lottie";
// import animation from "../Revoke/animation.json";

const ViewSecuritiesModal = ({ cancelFunction, name, orderArray }) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [activeOrder, setActiveOrder] = useState(0);

  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[1275px] !max-w-[95vw]  !justify-normal  relative !p-4 !text-left !h-fit !bg-[#f1f1f6] `}
      >
        <div className=" flex justify-end items-center mr-1">
          {/* <p className=" text-base font-semibold">Pledged Security Details</p> */}
          <button onClick={() => cancelFunction(false)}>
            <IoMdClose size={18} />
          </button>
        </div>
        <div className="w-full h-[91px] rounded-lg bg-white py-3 px-4 mt-3 ">
          <p className=" text-base font-bold">{name || "---"}</p>
          <div className=" w-full flex items-center space-x-6">
            <button
              className={` py-3  
               
                     border-b-[2px] border-[#00394d] 
                 
                 text-sm font-semibold `}
              onClick={() => {}}
            >
              {"Order " + 1}
            </button>
          </div>
        </div>
        <div className=" w-full mt-3  rounded-lg bg-white ">
          <div className="!max-h-[500px] overflow-y-auto p-4">
            <div>
              <p className="  text-base font-bold">List of Securities</p>
              <SecurityDetails data={orderArray} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSecuritiesModal;
